import { List, ListSchema } from '../../domain/list/ListDomains';
import { ReduxBaseAction } from '../../domain/redux/ReduxBaseAction';
import DeploymentModel from '../../domain/stream/model/DeploymentModel';
import { ComponentDependency } from '../../domain/ui/ComponentMetadata';

export type ListActions =
  | 'CHANGE_LIST'
  | 'CHANGE_LIST_IS_UPDATE'
  | 'CLEAR_LIST'
  | 'CHANGE_LIST_DATA'
  | 'CHANGE_LIST_CREATED_DATA'
  | 'CHANGE_LIST_DEPENDENCIES'
  | 'CHANGE_LIST_DIRTY';

export const changeList = (payload: List | null) =>
  ({
    type: 'CHANGE_LIST',
    payload,
  }) as ReduxBaseAction<List | null, ListActions>;

export const changeListIsUpdate = (payload: boolean) =>
  ({
    type: 'CHANGE_LIST_IS_UPDATE',
    payload,
  }) as ReduxBaseAction<boolean, ListActions>;

export const clearList = () =>
  ({
    type: 'CLEAR_LIST',
    payload: void 0,
  }) as ReduxBaseAction<void, ListActions>;

export const changeListData = (payload: Array<any>) =>
  ({
    type: 'CHANGE_LIST_DATA',
    payload,
  }) as ReduxBaseAction<Array<any>, ListActions>;

export const changeListCreatedData = (payload: Record<string, any> | null) =>
  ({
    type: 'CHANGE_LIST_CREATED_DATA',
    payload,
  }) as ReduxBaseAction<Array<any>, ListActions>;

export const changeListDependencies = (payload: ComponentDependency[]) =>
  ({
    type: 'CHANGE_LIST_DEPENDENCIES',
    payload,
  }) as ReduxBaseAction<ComponentDependency[], ListActions>;

export const changeListDirty = (payload: boolean) =>
  ({
    type: 'CHANGE_LIST_DIRTY',
    payload,
  }) as ReduxBaseAction<boolean, ListActions>;
